module.exports = __webpack_public_path__ + "static/media/intro-hero-blurbs.2a609d6b.png";